namespace TabAurous.Retail {
    export interface PosSalesPromoForm {
        TransId: Serenity.StringEditor;
        PromoId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.IntegerEditor;
        TotalAmount: Serenity.DecimalEditor;
        PromoPer: Serenity.DecimalEditor;
        PromoAmount: Serenity.DecimalEditor;
    }

    export class PosSalesPromoForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.PosSalesPromo';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PosSalesPromoForm.init)  {
                PosSalesPromoForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PosSalesPromoForm, [
                    'TransId', w0,
                    'PromoId', w1,
                    'ProductTypeId', w1,
                    'TotalAmount', w2,
                    'PromoPer', w2,
                    'PromoAmount', w2
                ]);
            }
        }
    }
}
